import { createSlice } from '@reduxjs/toolkit';

// Even auth token from the backend, remembered per phone number so it is fetched once per session and
// reused when an Even page opens. In memory only; cleared on logout with the rest of the store.
export interface EvenAuthState {
  phone: string | null;
  status: 'idle' | 'checking' | 'available' | 'unavailable';
  token?: string | null;
  issuedAt?: number | null;
}

interface initialStateInterface {
  choices: Array<object> | null;
  retailChoices: Array<object> | null;
  orgProducts: Array<object> | null;
  userDetails: object | null;
  banners: Array<object> | null;
  hasORPAccess: boolean | null;
  hasEvenQuicklnks: boolean | null;
  hasGiftCards: boolean | null;
  evenAuth: EvenAuthState;
  isCommercialOnly: boolean;
}

const initialState: initialStateInterface = {
  choices: null,
  retailChoices: null,
  orgProducts: null,
  userDetails: null,
  banners: null,
  hasORPAccess: null,
  isCommercialOnly: false,
  hasEvenQuicklnks: null,
  hasGiftCards: null,
  evenAuth: { phone: null, status: 'idle' },
};

const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setChoices: (state, action) => {
      state.choices = action.payload.choices;
    },
    setRetailChoices: (state, action) => {
      state.retailChoices = action.payload.choices;
    },
    setOrgProducts: (state, action) => {
      state.orgProducts = action.payload.orgProducts;
      state.isCommercialOnly = !action.payload.orgProducts?.policies.some((product: any) => product.provider_product_mapping.product.category !== 'commercial_insurance') && action.payload.orgProducts?.subscriptions.length <= 0;
    },
    setBanners: (state, action) => {
      state.banners = action.payload.banners;
      if (state.userDetails && (state.userDetails as any).organisation) {
        (state.userDetails as any).organisation.banners = action.payload.banners;
      }
    },
    setUserDetails: (state, action) => {
      const incoming = action.payload.userDetails;
      const prev = state.userDetails as any;
      state.userDetails = incoming
        ? {
            ...(prev || {}),
            ...incoming,
            organisation: {
              ...(prev?.organisation || {}),
              ...(incoming.organisation || {}),
              banners: state.banners || incoming.organisation?.banners || prev?.organisation?.banners || [],
            },
          }
        : null;
    },
    setHasORPAccess: (state, action) => {
      state.hasORPAccess = action.payload.hasORPAccess;
      state.hasEvenQuicklnks = action.payload.hasEvenQuicklnks;
      state.hasGiftCards = action.payload.hasGiftCards;
    },
    setEvenAuth: (state, action: { payload: EvenAuthState }) => {
      state.evenAuth = action.payload;
    },
    clearData: (state) => {
      return { ...initialState };
    },
  },
});

export const dataActions = dataSlice.actions;
export default dataSlice.reducer;
